import Home from "../Home";
import User from "../User";
import Shop from "../Shop";
import News from "../News";
import NewsEdit from '../NewsEdit';
import Main from "../User/Main";
import Info from "../User/Info";
import VideoList from '../Model/VideoList'
import NewVideo from '../NewVideo'
let rous = [
  {
    path: "/login/:id",
    component: Home,
    exact: true
  },
  {
    path: "/shop",
    component: Shop
  },
  {
    path: "/user",
    component: User,
    routes:[/*嵌套路由*/
      {
        path:"/user/",
        component:Main,
        exact:true
      },
      {
        path:"/user/info",
        component:Info
      }
    ]
  },
  {
    path: "/news",
    component: News
  },
  {
    path: "/news/videoAdd/:id",
    component: NewVideo
  },
  {
    path: "/pcontent/:id",
    component: NewsEdit
  },
  {
    path: "/news/videoList/:id",
    component: VideoList
  }
];
export default rous;



// WEBPACK FOOTER //
// ./src/components/Model/rous.js